import React, { ReactNode } from "react";
import HoverToolTip from "../utilities/HoverToolTip";

type FormSectionProps = {
  title: string;
  children: ReactNode;
  description?: string;
  tooltipText?: string;
  className?: string;
};

const FormSection = ({
  title,
  children,
  description,
  tooltipText,
  className = "",
}: FormSectionProps) => {
  return (
    <div className={`mb-8 ${className}`}>
      <div className="mb-4">
        <div className="flex items-center gap-2">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          {tooltipText && <HoverToolTip description={tooltipText} mt={0} />}
        </div>
        {description && (
          <p className="text-sm text-gray-600 mt-1">{description}</p>
        )}
      </div>
      <div className="bg-white p-6 rounded-lg border border-gray-200">
        {children}
      </div>
    </div>
  );
};

export default FormSection;
